<template>
	<div class="layout-img">
		<slot name="title"></slot>
		<template v-if="screenWidth > 768">
			<template v-for="(item, index) in list">
				<div :key="index" class="img-box">
					<a
						@click="toDetail(subitem.id)"
						v-for="(subitem, ind) in item"
						:key="ind"
						class="img-item"
						
					>
						<div
							class="tit"
							v-if="hidden"
							:style="{
								visibility: ind == 0 ? '' : 'hidden',
								position:
									item.length > 1 ? 'relative' : 'unset',
								left: item.length > 2 ? '118%' : '54%',
							}"
						>
							{{ subitem.awardName }}
						</div>
						<div class="tit" v-else>
							{{
								routeType == 'year'
									? subitem.awardName
									: subitem.awardYear
							}}
							{{ routeType == 'letter' ? subitem.awardName : '' }}
						</div>
						<div class="img-wrap img-hovor">
							<img
								width="100%"
								height="100%"
								:src="subitem.titleUrl"
							/>
						</div>
						<p
							style="
								text-align: center;
								color: #cfaf75;
								font-size: 1.2rem;
								margin-bottom: 0;
							"
						>
							{{ subitem.donorName }}
						</p>
						<p v-if="$i18n.locale == 'cn'" style="text-align: center; color: #999999;">
							{{ subitem.donorEnName }}
						</p>
					</a>
				</div>
			</template>
		</template>
		<template v-else>
			<div class="img-box">
				<template v-for="(subitem, ind) in flatList">
					<a
						@click="toDetail(subitem.id)"
						:key="ind"
						class="img-item"
					>
						<div class="tit">{{ subitem.awardName }}</div>
						<div class="img-wrap img-hovor">
							<img
								width="100%"
								height="100%"
								:src="subitem.titleUrl"
							/>
						</div>
						<p style="text-align: center; color: #cfaf75; margin-bottom: 0.5rem;">
							{{ subitem.donorName }}
						</p>
						<p v-if="$i18n.locale == 'cn'" style="text-align: center; color: #999999;">
							{{  subitem.donorEnName  }}
						</p>
					</a>
				</template>
			</div>
		</template>
	</div>
</template>
<script>
export default {
	props: {
		hidden: {
			//在获奖人中显示所有标题
			type: Boolean,
			default: true,
		},
		dataList: {
			type: Array,
			default: () => [
				{
					donorName: '获奖人',
					donorEnName: 'a',
					awardName: '生命科学奖',
					year: 2021,
					photoUrl:
						'http://www.futureprize.org/resource/data/uploads/84/45302d7c2fe7f96cbb0e1e9870819356.jpg',
					firstName: 'A',
				},
				{
					donorName: '获奖人2',
					donorEnName: 'b',
					awardName: '物质科学奖',
					year: 2020,
					photoUrl:
						'http://www.futureprize.org/resource/data/uploads/84/45302d7c2fe7f96cbb0e1e9870819356.jpg',

					firstName: 'B',
				},
				{
					donorName: '获奖人3',
					donorEnName: 'c',
					photoUrl:
						'http://www.futureprize.org/resource/data/uploads/84/45302d7c2fe7f96cbb0e1e9870819356.jpg',

					awardName: '物质科学奖',
					year: 2021,
					firstName: 'B',
				},
				{
					donorName: '获奖人3',
					donorEnName: 'c',
					photoUrl:
						'http://www.futureprize.org/resource/data/uploads/84/45302d7c2fe7f96cbb0e1e9870819356.jpg',

					awardName: '物质科学奖',
					year: 2021,
					firstName: 'B',
				},
				{
					donorName: '获奖人3',
					donorEnName: 'c',
					photoUrl:
						'http://www.futureprize.org/resource/data/uploads/84/45302d7c2fe7f96cbb0e1e9870819356.jpg',

					awardName: '物质科学奖',
					year: 2021,
					firstName: 'B',
				},
				{
					donorName: '获奖人3',
					donorEnName: 'c',
					photoUrl:
						'http://www.futureprize.org/resource/data/uploads/84/45302d7c2fe7f96cbb0e1e9870819356.jpg',

					awardName: '物质科学奖',
					year: 2021,
					firstName: 'B',
				},
				{
					donorName: '获奖人5',
					donorEnName: 'c',
					photoUrl:
						'http://www.futureprize.org/resource/data/uploads/84/45302d7c2fe7f96cbb0e1e9870819356.jpg',
					awardName: '计算机科学',
					year: 2021,
					firstName: 'B',
				},
				{
					donorName: '获奖人5',
					donorEnName: 'c',
					photoUrl:
						'http://www.futureprize.org/resource/data/uploads/84/45302d7c2fe7f96cbb0e1e9870819356.jpg',
					awardName: '计算机科学',
					year: 2021,
					firstName: 'B',
				},
			],
		},
	},
	data() {
		return {
			list: [],
			flatList: [],
			screenWidth: document.body.clientWidth,
			routeType: 'year',
		}
	},
    computed:{
        listebScreenWidth(){
            return this.$store.state.screenWidth
        }
    },
	
	watch: {
		dataList: {
			handler: 'dealData',
			immediate: true,
		},
		$route(val) {
			this.routeType = val.query.listBy
		},
		listebScreenWidth(val, newVal) {
			this.screenWidth = val
		},
	},
	methods: {
		dealData() {
			
			this.list = this.formatArr(this.dataList)
			this.flatList = this.flatArr(this.list)
		},
		toDetail(id) {
			this.$router.push('/donors/detail?id=' + id)
		},
		flatArr(arr) {
			return arr.flat()
		},
		//按奖项分类
		formatArr(arr) {
			let obj = {}
			arr.forEach((item) => {
				if (Object.keys(obj).indexOf(item.awardName) === -1) {
					obj[item.awardName] = []
				}
				obj[item.awardName].push(item)
			})
			return Object.values(obj)
		},
	},
}
</script>
<style lang="scss" scoped>
.layout-img {
	position: relative;
	width: 100%;
	overflow: hidden;
	.img-box {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		.img-item {
			display: block;
			width: 33.33%;
			padding-left: 1rem;
			padding-right: 1rem;
			text-decoration: none;
			cursor: pointer;
			.tit {
				// left: 104%;
				text-align: center;
				font-size: 1.2rem;
				margin-top: 1.6rem;
				margin-bottom: 1.6rem;
				color: #666666;
				visibility: visible;
			}
		}
	}
}
@media (min-width: 992px) {
	.img-wrap {
		width: 82%;
		height: 13.4rem;
		margin: 1rem auto;
	}
}

@media (max-width: 768px) {
	
	.layout-img {
		.img-box {
			justify-content: unset;
			.img-item {
				width: 50%;
				margin: 0;
				display: flex;
				flex-direction: column;
				align-items: center;
                .img-wrap{
                    margin: 1rem auto;
                }
				.tit {
                    min-width: 13rem;
                    min-height: 3.5rem;
                    display: flex;
                    align-items: center;
                    position: relative;
                    justify-content: center;
					margin: 0;
				}
			}
		}
	}
}
@media (max-width: 450px) {
    .img-wrap {
        width: 100%;
        height: 8.6rem;
    }
}
</style>
